import { EventEmitter } from '@angular/core';
import { AuthService } from 'app/security/auth.service';
import { ClientService } from 'app/services/client-service';
var ProfileContactComponent = /** @class */ (function () {
    function ProfileContactComponent(authService, clientService) {
        this.authService = authService;
        this.clientService = clientService;
        this.isCompany = true;
        // El banner de "perfil completo" solo se muestra cuando el perfil está al 100%.
        this.show = false;
        this.profileAction = new EventEmitter();
    }
    ProfileContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        if ((this.authService.isLogged())) {
            var user = this.authService.getUser();
            user.documentType && user.documentType == 'CIF' ? this.isCompany = true : this.isCompany = false;
        }
        this.clientService.observerClientPercentageObserved().subscribe(function (result) {
            _this.show = (result === 100);
        });
    };
    Object.defineProperty(ProfileContactComponent.prototype, "phone", {
        get: function () {
            var phonePrefix = '';
            var phone = '';
            if (this.profileData) {
                if (this.profileData.phonePrefix) {
                    phonePrefix = '+' + this.profileData.phonePrefix + ' ';
                }
                if (this.profileData.phone) {
                    phone = this.profileData.phone;
                }
            }
            if (phone !== '' && phone !== null && phone !== 'null') {
                return phonePrefix + phone;
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileContactComponent.prototype, "mobilePhone", {
        get: function () {
            var phonePrefix = '';
            var phone = '';
            if (this.profileData) {
                if (this.profileData.mobilePhonePrefix) {
                    phonePrefix = '+' + this.profileData.mobilePhonePrefix + ' ';
                }
                if (this.profileData.mobilePhone) {
                    phone = this.profileData.mobilePhone;
                }
            }
            if (phone !== '' && phone !== null && phone !== 'null') {
                return phonePrefix + phone;
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileContactComponent.prototype, "poblacion", {
        get: function () {
            if (!this.profileData) {
                return '';
            }
            var cp = this.profileData.zip || this.profileData.postalCode || '';
            var city = this.profileData.cityDescription || '';
            var prov = this.profileData.province || '';
            return [cp, [city, prov].filter(Boolean).join(', ')].filter(Boolean).join(' ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileContactComponent.prototype, "birthDateFormatted", {
        // Fecha de nacimiento con guiones (dd-mm-aaaa), como el resto de la app.
        get: function () {
            return (this.profileData && this.profileData.birthDate)
                ? this.profileData.birthDate.replace(/\//g, '-')
                : '';
        },
        enumerable: true,
        configurable: true
    });
    ProfileContactComponent.prototype.onEditClick = function () {
        this.profileAction.emit({ section: 'profile-modification' });
    };
    return ProfileContactComponent;
}());
export { ProfileContactComponent };
